const nbMarketText = JSON.parse(document.getElementById("nb-market-text").textContent);
(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-purchase]').forEach(box => {
      if (box.dataset.ready) return;
      const data = JSON.parse(box.querySelector('[data-purchase-data]').textContent);
      const form = box.querySelector('form');
      const planSelect = box.querySelector('[data-plan]');
      const modePicker = box.querySelector('[data-purchase-modes]');
      if (modePicker) modePicker.hidden = false;
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {style:'currency', currency:data.currency}).format(cents / 100);
      const selectedVariant = () => data.variants.find(v => String(v.id) === form.querySelector('[name="id"]:checked')?.value);
      const showPrice = () => {
        const v = selectedVariant(); if (!v) return;
        const plan = v.plans.find(p => String(p.id) === planSelect?.value);
        box.querySelectorAll('[data-klarna-reassurance]').forEach(el => { el.hidden = Boolean(plan); });
        const price = plan ? plan.price : v.price;
        const compare = plan ? plan.compare : v.compare;
        const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]').value) || 1);
        const summary = box.querySelector('[data-purchase-summary]');
        if (summary) summary.textContent = quantity + ' × ' + (v.title || '') + ' · ' + (plan ? plan.name : nbMarketText.once);
        box.querySelector('[data-price]').textContent = money(price * quantity) + (plan ? ' '+nbMarketText.per_delivery.trim() : '');
        const old = box.querySelector('[data-compare]');
        old.hidden = !(compare > price); old.textContent = compare > price ? money(compare * quantity) : '';
        box.querySelector('[data-saving]').textContent = compare > price ? nbMarketText.saving.trim() + ' ' + money((compare - price) * quantity) : '';
        const description = box.querySelector('[data-plan-description]');
        if (description) description.textContent = plan?.description || '';
        const recurring = box.querySelector('[data-recurring-note]'); if (recurring) recurring.hidden = !plan;
        box.querySelectorAll('[data-add]').forEach(add => {
          add.disabled = !v.available || (data.requiresPlan && !plan);
          add.textContent = !v.available ? data.labels.soldOut : add.hasAttribute('data-buy-now') ? (plan ? data.labels.subscribe : data.labels.buy) : data.labels.cart;
        });
        if (modePicker) {
          modePicker.querySelectorAll('input').forEach(input => {
            input.checked = input.value === (plan || data.requiresPlan ? 'subscribe' : 'once');
            input.disabled = input.value === 'subscribe' && !v.plans.length;
          });
          box.querySelector('[data-plan-picker]').hidden = !plan && !data.requiresPlan;
        }
        const url = new URL(location.href); url.searchParams.set('variant',v.id);
        if(plan) url.searchParams.set('selling_plan',plan.id); else url.searchParams.delete('selling_plan');
        history.replaceState({},'',url);
      };
      const updateVariant = () => {
        const v = selectedVariant(); if (!v) return;
        if(planSelect){
          const previous = planSelect.value;
          planSelect.replaceChildren();
          if(!data.requiresPlan) planSelect.add(new Option(nbMarketText.once,''));
          v.plans.forEach(p => planSelect.add(new Option(p.name + ' — ' + money(p.price) + nbMarketText.per_delivery,String(p.id))));
          if(v.plans.some(p => String(p.id) === previous)) planSelect.value = previous;
          else if(!data.requiresPlan) planSelect.value = '';
          box.querySelector('[data-plan-picker]').hidden = !v.plans.length;
        }
        showPrice();
      };
      form.querySelectorAll('[name="id"]').forEach(input => input.addEventListener('change',updateVariant));
      planSelect?.addEventListener('change',showPrice);
      form.querySelector('[name="quantity"]').addEventListener('input',showPrice);
      modePicker?.querySelectorAll('input').forEach(input => input.addEventListener('change', () => {
        planSelect.value = input.value === 'subscribe' ? String(selectedVariant()?.plans[0]?.id || '') : '';
        showPrice();
      }));
      const initialPlan = new URL(location.href).searchParams.get('selling_plan');
      if(planSelect && selectedVariant()?.plans.some(p => String(p.id) === initialPlan)) planSelect.value = initialPlan;
      form.addEventListener('submit', e => {
        const v = selectedVariant();
        if(!v?.available || (data.requiresPlan && !planSelect?.value)) {
          e.preventDefault(); box.querySelector('[data-purchase-status]').textContent = nbMarketText.choose;
        }
      });
      box.dataset.ready = 'true'; showPrice();
    });
  };
  init(); document.addEventListener('shopify:section:load', e => init(e.target));
})();

(() => {
  const initDiscovery = (root = document) => {
    root.querySelectorAll('[data-formula-finder]').forEach(finder => {
      if (finder.dataset.enhanced) return;
      const filters = finder.querySelector('.formula-filters');
      const buttons = [...filters.querySelectorAll('[data-formula-filter]')];
      const cards = [...finder.querySelectorAll('[data-formula-kind]')];
      filters.hidden = false;
      buttons.forEach(button => button.addEventListener('click', () => {
        const filter = button.dataset.formulaFilter;
        buttons.forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        cards.forEach(card => { card.hidden = filter !== 'all' && !card.dataset.formulaKind.split(' ').includes(filter); });
        const count = cards.filter(card => !card.hidden).length;
        finder.querySelector('[data-formula-count]').textContent = count + (count === 1 ? ' '+nbMarketText.formula : ' '+nbMarketText.formulas) + ' · ' + button.textContent;
      }));
      finder.dataset.enhanced = 'true';
    });
    root.querySelectorAll('[data-mobile-menu]').forEach(menu => {
      if (menu.dataset.enhanced) return;
      menu.addEventListener('click', e => { if (e.target.closest('a')) menu.open = false; });
      menu.addEventListener('keydown', e => { if (e.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
      menu.dataset.enhanced = 'true';
    });
  };
  initDiscovery(); document.addEventListener('shopify:section:load', e => initDiscovery(e.target));
})();

(() => {
 const initGalleries = (root = document) => root.querySelectorAll('[data-gallery]').forEach(gallery => {
  if (gallery.dataset.galleryReady) return;
  const image = gallery.querySelector('[data-gallery-image]');
  const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
  const stage = gallery.querySelector('.nb-gallery-stage');
  let index = 0;
  const show = next => {
   index = (next + thumbs.length) % thumbs.length;
   image.src = thumbs[index].dataset.image;
   image.alt = thumbs[index].dataset.alt;
   thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
   gallery.querySelector('[data-gallery-status]').textContent = `${index + 1} / ${thumbs.length}`;
  };
  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
  gallery.querySelector('[data-gallery-prev]').addEventListener('click', () => show(index - 1));
  gallery.querySelector('[data-gallery-next]').addEventListener('click', () => show(index + 1));
  gallery.addEventListener('keydown', event => {
   if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();show(index + (event.key === 'ArrowRight' ? 1 : -1));}
  });
  let touchStart = null;
  stage.addEventListener('touchstart', event => {touchStart = event.touches.length === 1 ? {x:event.touches[0].clientX,y:event.touches[0].clientY} : null;}, {passive:true});
  stage.addEventListener('touchend', event => {
   if (!touchStart || !event.changedTouches.length) return;
   const dx = event.changedTouches[0].clientX - touchStart.x;
   const dy = event.changedTouches[0].clientY - touchStart.y;
   if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
   touchStart = null;
  }, {passive:true});
  gallery.querySelector('[data-gallery-controls]').hidden = thumbs.length < 2;
  gallery.dataset.galleryReady = 'true';
 });
 initGalleries();document.addEventListener('shopify:section:load', event => initGalleries(event.target));
})();
